// src/pages/DirectoryPage.jsx
import React from "react";
import People from "../components/People";

const DirectoryPage = () => {
  return (
    <div className="px-4 mt-6">
      <div className="mx-auto max-w-7xl">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-center mb-4">
          Sand Cherry Directory
        </h1>
        <People />
      </div>
    </div>
  );
};

export default DirectoryPage;